export const FORM_VIEWED_EVENT = 'form_viewed';
export const FORM_FIELD_INTERACTED = 'form_field_interacted';
export const FEATURE_VIEWED_EVENT = 'feature_viewed';
export const LINK_VIEWED_EVENT = 'link_viewed';

export type EventType =
  | 'form_viewed'
  | 'form_field_interacted'
  | 'feature_viewed'
  | 'link_viewed';
